<template>
  <div class="container">
    <h2 id="h2name mt-4" class="h3 mb-5">{{ $t('ministries_title') }}</h2>
    <div class="mb-5 row">
      <span class="col-md-5 mb-3 mr-3 ml-3 pl-0" v-for="ministry in ministries" v-bind:key="ministry.id">
            <router-link :to="{ name: 'ministry', params: { lang: language, acronym: ministry.acronym.toLowerCase() } }">{{ ministry.name }}</router-link>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      ministries: null,
      loading: true,
      errored: false
    }
  },
  computed: {
    language() {
      return this.$root.$i18n.locale
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'ministries', {
          params: {
            language: this.$root.$i18n.locale
          }
        })
        .then(response => {
          this.ministries = response.data.data
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (this.loading = false))
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>
